import React from 'react';

import styles from './index.module.scss';

const Required = ({ children }) => {
  return (
    <>
      {children}
      <sup className={styles.required}>*</sup>
    </>
  );
};

export default Required;
